module.exports = __webpack_public_path__ + "technologies.1p6bTu-m.svg";